import { render, staticRenderFns } from "./chatMessage.vue?vue&type=template&id=60f6e114&scoped=true&"
import script from "./chatMessage.vue?vue&type=script&lang=ts&"
export * from "./chatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./chatMessage.vue?vue&type=style&index=0&id=60f6e114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6e114",
  null
  
)

export default component.exports